import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NotificationService, NotificationMessage } from '../../services/notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toast-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-notification.component.html',
  styleUrls: ['./toast-notification.component.css']
})
export class ToastNotificationComponent implements OnInit, OnDestroy {
  notifications: NotificationMessage[] = [];
  private subscription: Subscription = new Subscription();

  constructor(
    private notificationService: NotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.notificationService.getNotifications().subscribe(notifications => {
        this.notifications = notifications.slice(0, 5); // Limit to 5 visible notifications
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Handle notification click
   */
  onNotificationClick(notification: NotificationMessage): void {
    if (notification.type === 'order') {
      // Navigate to orders and highlight new orders
      this.router.navigate(['/dashboard/orders']);
      
      // Store highlight information
      if (notification.orderIds) {
        sessionStorage.setItem('highlightOrders', JSON.stringify({
          orderIds: notification.orderIds,
          timestamp: Date.now(),
          duration: 30000 // 30 seconds
        }));
      }
    }

    // Remove the notification after click
    this.removeNotification(notification.id);
  }

  /**
   * Remove notification
   */
  removeNotification(id: string): void {
    this.notificationService.removeNotification(id);
  }

  /**
   * Get notification icon based on type
   */
  getNotificationIcon(type: string): string {
    switch (type) {
      case 'order':
        return 'bi bi-bag-check-fill';
      case 'document':
        return 'bi bi-file-earmark-text-fill';
      case 'system':
        return 'bi bi-info-circle-fill';
      default:
        return 'bi bi-bell-fill';
    }
  }

  /**
   * Get notification color class based on type
   */
  getNotificationClass(type: string): string {
    switch (type) {
      case 'order':
        return 'toast-order';
      case 'document':
        return 'toast-document';
      case 'system':
        return 'toast-system';
      default:
        return 'toast-default';
    }
  }

  /**
   * Format timestamp for display
   */
  formatTimestamp(timestamp: Date): string {
    const now = new Date();
    const diff = now.getTime() - timestamp.getTime();
    const seconds = Math.floor(diff / 1000);
    
    if (seconds < 60) {
      return 'just now';
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return `${minutes}m ago`;
    } else {
      const hours = Math.floor(seconds / 3600);
      return `${hours}h ago`;
    }
  }

  /**
   * TrackBy function for notifications
   */
  trackByNotificationId(index: number, notification: NotificationMessage): string {
    return notification.id;
  }
}




